<h3 class="title configurator-title">{{ 'fence.configuration.title' | translate }}</h3>
<div class="config-container shadow">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 1 }"
    (click)="toggleCollapse(1)">
    <span>{{ 'fence.configuration.shape' | translate }}</span>
  </h4>
  <div class="collapse-block" *ngIf="subStep === 1">
    <div class="shape-container">
      <div
        class="shape-card"
        [ngClass]="{ active: isShapeSelected(shape) }"
        *ngFor="let shape of shapes"
        (click)="selectShape(shape)">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAQAAAC0NkA6AAAALUlEQVR42u3NMQEAAAgDINc/9Mzg4QcFSDvvIpFIJBKJRCKRSCQSiUQikUhuFtAOY89wCn1dAAAAAElFTkSuQmCC"
          alt="shape-img"
          class="shape-img"
          *ngIf="shape.id === 0" />
        <img [src]="baseImgURL + shape.icon" alt="shape-img" class="shape-img" *ngIf="shape?.id !== 0" />
        <p class="shape-title">{{ shape.nameFr }}</p>
      </div>
      <ng-casto-loader *ngIf="shapes === undefined"></ng-casto-loader>
    </div>

    @if (configuration.shape?.sidesCount === 1)
    {
      <!--Confirmer que la forme n'a pas d'angles-->
      <div class="confirm-angle">
        <p>{{ 'fence.configuration.confirm-angle' | translate }}</p>
        <ng-casto-btn
          class="light-grey yes"
          [active]="configuration.confirmNoAngle === true"
          [label]="'generic.yes' | translate"
          (click)="confirmAngle(false)">
        </ng-casto-btn>

        <ng-casto-btn
          class="light-grey no"
          [active]="configuration.confirmNoAngle === false"
          [label]="'generic.no' | translate"
          (click)="confirmAngle(true)">
        </ng-casto-btn>
      </div>
    }

    @if (((configuration.shape?.isFree || configuration.shape?.id === 0)
      || configuration.shape?.sidesCount !== 1)
      && configuration.shape !== undefined){
      <!--Nombre d'angles non droits-->
      <div class="form-row">
        <div class="form-label">
          <label for="nbNonRightAngle">
            {{ 'fence.configuration.nb-non-right-angle' | translate }}
          </label>
          <div class="info-kit-chip" (click)="getInfosAngleKit()">
            {{ 'fence.configuration.multi-angle-kit-info' | translate }}
          </div>
        </div>
        <div class="form-input">
          <div class="number">
            <input
              type="number"
              id="nbNonRightAngle"
              min="0"
              max="50"
              spellcheck="false"
              [(ngModel)]="configuration.nbNonRightAngle" />
          </div>
        </div>
      </div>

      <!--Nombre d'angle en pilier de pierre-->
      @if (configuration.location.isOnWall) {
        <div class="form-row">
          <div class="form-label">
            <label for="nbConcretePilarAngle">{{ 'fence.configuration.nb-concrete-pilar-angle' | translate }}</label>
          </div>
          <div class="form-input">
            <div class="number">
              <input
                type="number"
                id="nbConcretePilarAngle"
                min="0"
                max="50"
                spellcheck="false"
                [(ngModel)]="configuration.nbConcretePilarInAngle" />
            </div>
          </div>
        </div>
      }
    }

    <div *ngIf="configuration.shape !== undefined && (configuration.shape?.isFree || configuration.shape?.id === 0)">
      <!--Nombre de côtés de la forme libre-->
      <div class="form-row">
        <div class="form-label">
          <label for="sideCount">{{ 'fence.configuration.side-count-label' | translate }}</label>
        </div>
        <div class="form-input">
          <div class="number">
            <input
              type="number"
              id="sideCount"
              min="1"
              max="26"
              spellcheck="false"
              (change)="selectSideCount($event)"
              [value]="configuration.sides.length" />
          </div>
        </div>
      </div>

      <!--La forme est-elle fermée ?-->
      <div class="form-row">
        <div class="form-label d-inline">
          <label for="isClosed">
            {{ 'fence.configuration.is-closed' | translate }}
          </label>
        </div>
        <div class="form-switch">
          <span class="mr-2">{{ 'fence.configuration.no' | translate }}</span>
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="isClosed"
              [(ngModel)]="configuration.isShapeClosed" />
            <label class="custom-control-label" for="isClosed">
              {{ 'fence.configuration.yes' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="config-container shadow mt-4" *ngIf="configuration.sides !== undefined && configuration.sides.length > 0">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 2 }"
    (click)="toggleCollapse(2)">
    <span>{{ 'fence.configuration.fence-size' | translate }}</span>
    <span class="title-count"
      >{{ configuration.sides.length }} {{ 'fence.configuration.available-sides' | translate }}</span
    >
  </h4>

  <div class="collapse-block" *ngIf="subStep === 2">
    <div *ngIf="configuration.shape !== undefined">
      <div class="sides-wrapper">
        <div class="sides-container">
          <div class="side-card" *ngFor="let side of configuration.sides">
            <h5 class="side-title">{{ side.id }}</h5>
            <button class="side-add-button" (click)="addSection(side.id)">
              + {{ 'fence.configuration.add-height' | translate }}
            </button>

            <div *ngFor="let section of side.sections; let index = index" class="section">
              <h5 class="section-title">{{ 'fence.configuration.section' | translate }} {{ index + 1 }}</h5>

              <div class="section-form">
                <!-- Hauteur -->
                <div class="form-row">
                  <div class="form-label">
                    <label>{{ 'fence.configuration.height' | translate }}</label>
                  </div>
                  <div class="form-input form-select">
                    <select name="height" [(ngModel)]="section.height" (change)="resetPosts()">
                      <option
                        *ngFor="let height of heights"
                        [value]="height.height"
                        [selected]="section.height === height.height">
                        {{ height.nameFr }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Longueur -->
                <div class="form-row">
                  <div class="form-label">
                    <label>{{ 'fence.configuration.length' | translate }}</label>
                  </div>
                  <div class="form-input">
                    <div class="m">
                      <input
                        type="number"
                        min="1"
                        max="999999"
                        spellcheck="false"
                        step="0.01"
                        [value]="section.length | convertDistance: false : 100"
                        (change)="changeLength($event, section)" />
                    </div>
                  </div>
                </div>

                <!-- Portillon -->
                <div *ngIf="sectionCanHaveDoors(section)" class="form-row">
                  <div class="form-label">
                    <label for="hasDoor-{{ side.id }}{{ index }}">
                      {{ 'fence.configuration.has-door' | translate }}
                    </label>
                  </div>
                  <div class="form-switch">
                    <span class="mr-2">{{ 'fence.configuration.no' | translate }}</span>
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="hasDoor-{{ side.id }}{{ index }}"
                        [(ngModel)]="section.hasDoor" />
                      <label class="custom-control-label" for="hasDoor-{{ side.id }}{{ index }}">{{
                        'fence.configuration.yes' | translate
                      }}</label>
                    </div>
                  </div>
                </div>

                <!-- Plaques de soubassement -->
                <div class="form-row" *ngIf="configuration.location.isSealed">
                  <div class="form-label">
                    <div class="d-inline">
                      <label for="hasBasePlate-{{ side.id }}{{ index }}">
                        {{ 'fence.configuration.has-base-plate' | translate }}
                      </label>
                      <span (click)="getInfosBasePlate()"><a class="casto-tooltip">?</a></span>
                    </div>
                    <small>{{ 'fence.configuration.base-plate-infos' | translate }}</small>
                  </div>
                  <div class="form-switch">
                    <span class="mr-2">{{ 'fence.configuration.no' | translate }}</span>
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="hasBasePlate-{{ side.id }}{{ index }}"
                        [(ngModel)]="section.hasBasePlates" />
                      <label class="custom-control-label" for="hasBasePlate-{{ side.id }}{{ index }}">{{
                        'fence.configuration.yes' | translate
                      }}</label>
                    </div>
                  </div>
                </div>

                <!-- Départ mural -->
                <div *ngIf="isNotSealed()" class="form-row">
                  <div class="form-label">
                    <label for="wallStart-{{ side.id }}{{ index }}">
                      {{ 'fence.configuration.wall-start' | translate }}
                    </label>
                  </div>
                  <div class="form-switch">
                    <span class="mr-2">{{ 'fence.configuration.no' | translate }}</span>
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="wallStart-{{ side.id }}{{ index }}"
                        [(ngModel)]="section.wallStart" />
                      <label class="custom-control-label" for="wallStart-{{ side.id }}{{ index }}">
                        {{ 'fence.configuration.yes' | translate }}
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Fin mural -->
                <div *ngIf="isNotSealed()" class="form-row">
                  <div class="form-label">
                    <label for="wallEnd-{{ side.id }}{{ index }}">{{
                      'fence.configuration.wall-end' | translate
                    }}</label>
                  </div>
                  <div class="form-switch">
                    <span class="mr-2">{{ 'fence.configuration.no' | translate }}</span>
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="wallEnd-{{ side.id }}{{ index }}"
                        [(ngModel)]="section.wallEnd" />
                      <label class="custom-control-label" for="wallEnd-{{ side.id }}{{ index }}">
                        {{ 'fence.configuration.yes' | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="section-button-container">
                <div class="section-duplicate">
                  <button (click)="duplicateSection(side.id, section)" class="section-duplicate-button">
                    <svg>
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="assets/img/icons.svg#icon-action-duplicate"></use>
                    </svg>
                  </button>
                </div>
                <div class="section-delete">
                  <button (click)="deleteSection(side.id, index)" class="section-delete-button">
                    <svg>
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
